import React from 'react';
import ArrowBack from '@mui/icons-material/ArrowBack';
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    background: theme.palette.common.white,
    color: theme.palette.text.primary,
  },
  toolbar: {
    padding: 0,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const FullScreenDialog = ({
  isOpen,
  contentClassName,
  title,
  children,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog fullScreen open={isOpen}>
      <AppBar className={classes.appBar} elevation={0}>
        <Toolbar className={classes.toolbar} variant="dense">
          <IconButton
            onClick={onClose}
            color="inherit"
            aria-label="close"
            size="large"
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Divider />
      <DialogContent className={classNames(contentClassName)}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenDialog;
